module.exports = __webpack_public_path__ + "static/analytics-new-product@3x-2592b87adf8308fa92daae26c95759e4.png";